// = Libs =
import { FC } from "react";

// === Style ===
import classes from "./report-card.module.scss";

// === Components ===
import Card from "@/common/components/core/card/card";
import CardHeader from "@/common/components/core/card/card-header/card-header";
import CardBody from "@/common/components/core/card/card-body/card-body";

// === Icons ===
import IconButton from "@/common/components/ui/buttons/icon-button/icon-button";
import { API_INSTANCE } from "@/constants/api";
import { mutate } from "swr";
import { useParams } from "react-router-dom";
import { assistantService } from "@/services/assistant/assistant.service";
import { ReportCardModel } from "@/services/report.service";

// = Types =

const approve = async (id: string | number, pollId: string) => {
  await API_INSTANCE.patch(`/monitoring-api/reports/${id}/commit/accept/`, {
    'message': 'Принято',
  });
  mutate(`monitoring-api/polls/${pollId}/reports`, undefined, true);
};

const refill = async (id: string | number, pollId: string) => {
  await API_INSTANCE.patch(`/monitoring-api/reports/${id}/commit/reject/`, {
    comment: { content: 'Необходима доработка' },
  });
  mutate(`monitoring-api/polls/${pollId}/reports`, undefined, true);
};

const ReportCard: FC<ReportCardModel> = ({
  id,
  title,
  status,
  statusColor,
  link,
  createDt,
  updateDt,
  comments,
  buttons = false,
  executorId,
}) => {
  const pollId = useParams<{ id: string }>().id;

  return (
    <div>
      <Card className={classes.cards}>
        <CardHeader
          label={status}
          labelColor={statusColor}
          className={classes['cards-header']}>
          {status === 'На утверждении' && (
            <a
              onClick={async () => await assistantService.getSignedDocument(id)}
              href={'#'}>
              Скачать отчет
            </a>
          )}
        </CardHeader>
        <CardBody className={classes['cards-body']}>
          <div className={classes['cards__title']}>
            <a href={`/poll/${pollId}/report/${executorId}/`}>
              {String(title)}
            </a>
          </div>
          {buttons ? (
            <ul className={classes['cards-buttons__list']}>
              <li>
                <IconButton
                  type={'submit'}
                  color={'primary'}
                  iconType={'accept'}
                  onClick={() => approve(id, pollId)}
                />
              </li>
              <li>
                <IconButton
                  type={'submit'}
                  color={'secondary'}
                  iconType={'delete'}
                  onClick={() => refill(id, pollId)}
                />
              </li>
            </ul>
          ) : (
            ''
          )}
        </CardBody>
        <div className={classes['cards-comment']}>
          {comments?.map((com) => (
            <p>{com}</p>
          ))}
        </div>
        <div className={classes['cards-aside']}>
          <div className={classes['cards-create-update']}>
            <p>Взят в работу: {String(createDt)}</p>
            <p>Последнее обновление: {String(updateDt)}</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ReportCard;
